import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { QuoteConceptPayload } from "../types";

export const addQuoteConcept = (payload: QuoteConceptPayload) => {
   return apiClient<ApiResponse>("/v1/quote/concept", {
      method: "POST",
      body: payload
   })
}
